import { render } from "./MultiSelectorField.vue?vue&type=template&id=8c2af236"
import script from "./MultiSelectorField.vue?vue&type=script&lang=js"
export * from "./MultiSelectorField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__